import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';

@Component({
  selector: 'hirek',
  templateUrl: './hirek.component.html',
  styleUrls: ['./hirek.component.scss']
})
export class HirekComponent implements OnInit {

  constructor(private _renderer2: Renderer2,
    @Inject(DOCUMENT) private _document: Document) { }

  ngOnInit(): void {
    this.setEmailClick();
  }


  setEmailClick(): void {
    const emailKar = this._document.getElementById('emailKar');
    if (emailKar) {
      emailKar.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
        const u = 'kar';
        const d = 'granitbiztosito.hu';
        const email = `${u}@${d}`;
        window.location.href = `mailto:${email}`;
      });
    }

    const emailUgyfel = this._document.getElementById('emailValtozas');
    if (emailUgyfel) {
      emailUgyfel.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
        const u = 'ugyfelszolgalat';
        const d = 'granitbiztosito.hu';
        const email = `${u}@${d}`;
        window.location.href = `mailto:${email}`;
      });
    }

    const emailPanasz = this._document.getElementById('emailPanasz');
    if (emailPanasz) {
      emailPanasz.addEventListener('click', (event: MouseEvent) => {
        event.preventDefault();
        const u = 'panaszugyek';
        const d = 'granitbiztosito.hu';
        const email = `${u}@${d}`;
        window.location.href = `mailto:${email}`;
      });
    }
  }

}
